module.exports = __webpack_public_path__ + "static/placeholdifier-translate-ebd4378b75c1e3b33dba14271fa8e92e.png";